import { Modal, ModalProps } from "@kernel/react-ui-kit";
import React, { useCallback, useEffect, useState } from "react";
import { DialogState, useGlobalDialogBloc } from "@modules";

interface DialogProps extends Omit<ModalProps, "backdrop" | "children"> {
  dialog: DialogState;
  hasBackdrop: boolean;
  onClose: () => void;
}

function Dialog({ dialog, hasBackdrop }: DialogProps) {
  const [show, setShow] = useState(false);
  const {
    open,
    size,
    fullscreen,
    component: ModalBody,
    props: dialogProps
  } = dialog;

  useEffect(() => {
    setShow(open);
  }, [open]);

  const handleClose = useCallback(() => {
    setShow(false);
    setTimeout(() => {
      if (!dialogProps) return;
      dialogProps.onClose && dialogProps.onClose();
    }, 500);
  }, []);

  return (
    <Modal
      show={show}
      size={size}
      fullscreen={fullscreen}
      {...dialogProps}
      backdrop={hasBackdrop}
      onClose={handleClose}
    >
      {ModalBody}
    </Modal>
  );
}

export function DialogsContainer() {
  const modal = useGlobalDialogBloc();
  return (
    <React.Fragment>
      {modal.stack.toArray().map((dialog, index) => (
        <Dialog
          dialog={dialog}
          key={index}
          hasBackdrop={index === 0}
          onClose={modal.onClose}
        />
      ))}
    </React.Fragment>
  );
}
